<template>
  <div id="c-python-runtime" :style="isSkulptDraw || isShowFrame ? styleW : styleNW">

    <div v-show="this.isSkulptDraw || isShowFrame" class="python-runtime-title-bar" @click="showFrame(!isShowFrame)" :style="isSkulptDraw ? '' : 'cursor: pointer;'">
      <template v-if="!isSkulptDraw">
        <i v-if="isShowFrame" class="el-icon-caret-right"></i>
        <i v-else class="el-icon-caret-left"></i>
      </template>
      <span v-else style="padding-left: 5px"></span>
      <span>绘图显示区：</span>
    </div>
    <div class="mycanvas" id="mycanvas"></div>
    <div v-if="resizeType == 'h'" class="python-over"></div>
  </div>
</template>

<script type="text/babel">
  import { mapGetters } from 'vuex';
  import {initScripts} from '../../utils/installScript';
  import {onEvent, emitEvent} from '../../utils/eventBus/vueEvent'
  import Events from '../../scripts/events/index'
  import iframe from '../../scripts/iframe/index'
  import consoleStyle from '../../components/ide/consoleStyle'

  let Sk = null;

  export default {
    name: 'ace-editor',
    props: {
      resizeType: String
    },
    computed: {
      ...mapGetters(['isSkulptDraw', 'isRunLocal', 'skulptReady', 'isPyRuntimeCom']),
    },
    data() {
      return {
        code: '',
        isShowFrame: false,
        styleW: 'width: 480px;',
        styleNW: 'width: 10px; border-left: none;',
        inputCallback: null,
        isRemote: true,
      }
    },
    mounted() {

      onEvent(Events.RUN_PYTHON_CODE_LOCAL, (code, stop) => {
        if (stop) {
          this.runCode('print(" ")');
          emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getRun('...停止运行') })
          return;
        }
        this.runCode(code);
        // emitEvent(Events.RUN_CODE_RUN_RES, { Code: 0, data: {} })
        Events.emitIframeEvent({ method: iframe.PYTHON_RUN_RES, data: { Code: 0, data: {} }, type: 'inputRes' })
      })

      onEvent(Events.PYTHON_SET_INPUT, data => {
        // Events.emitIframeEvent({ method: iframe.YOUTH_OUTPUT, data: data, type: 'inputRes' })
        if (this.inputCallback) {
          this.inputCallback(data);
        } else {
          console.error('pythonRuntimeCom inputCallback == null');
        }
      })

      console.log('com -python--runtime:');
      this.loadIde(this.isRemote);
    },
    methods: {
      loadIde(isRemote) {
        const cloudBaseUrl = isRemote ?
                'https://qceit-static-1258274959.cos.ap-guangzhou.myqcloud.com/editor/skulpt0-9/'
                : `${location.origin}/static/skulpt0-9/`;
        initScripts(
                `${cloudBaseUrl}dist/skulpt.min.js`
        ).then(() => {

          initScripts(
                  `${cloudBaseUrl}dist/skulpt-stdlib.js`
          ).then(() => {

            this.initSk();
          }).catch((err) => {
            console.error('initScripts skulpt-stdlib err:', err);
            this.initSk(1);
          })
        }).catch((err) => {
          console.error('initScripts skulpt.min err:', err);
          this.initSk(2);
        })
      },
      initSk(errNo) {
        if (errNo || !window.Sk) {
          if (this.isRemote) {
            console.error(`initSk err: ${errNo}，isRemote`, this.isRemote)
            this.isRemote = false;
            this.loadIde(this.isRemote);
          } else {
            emitEvent(Events.OUTPUT_CONSOLE, `python运行时初始化异常: ${errNo}，请尝试其他网络连接方式`);
            console.error(`python运行时初始化异常: ${errNo}，请尝试其他网络连接方式`, window.Sk);
          }
          return;
        }

        Sk = window.Sk;
        Sk.pre = "output";
        Sk.configure({
          output: this.runOutput,
          read: this.builtinRead,
          inputfun: this.skulptInput,
          __future__: Sk.python3
        });
        Sk.TurtleGraphics = {
          target: 'mycanvas',
          width: 480,
          height: 480
        }
        if (this.code) {
          this.runCode(this.code)
        }

        Events.emitIframeEvent({ method: iframe.PYTHON_READY, data: 'v1.6.8c' })
      },
      runCode(code) {
        // console.log('run code com:', code);
        if (!Sk) {
          console.error('pythonRuntime python Sk init Error v1.1.0:')
          Events.emitIframeEvent({ method: iframe.PYTHON_RUN_RES, data: { Code: 1404, Msg: 'python Sk init Error v1.1.1:'} })
        } else {
          Events.emitIframeEvent({ method: iframe.PYTHON_RUN_RES, data: { Code: 0, Msg: 'ok'} })
        }
        let myPromise = Sk.misceval.asyncToPromise(function () {
          return Sk.importMainWithBody('<stdin>', false, code, true)
        })
        myPromise.then(res => {
            console.log('pythonRuntime success v1.1.0c:', res)
            Events.emitIframeEvent({ method: iframe.PYTHON_RUN_END, data: true })
          },
          err => {
            console.error('pythonRuntime end err v1.1.0c:', err);
            Events.emitIframeEvent({ method: iframe.YOUTH_OUTPUT, data: err && err.toString() || 'error' })
            Events.emitIframeEvent({ method: iframe.PYTHON_RUN_END, data: false })
          })
      },
      runOutput(text) {
        console.log('runOutput---com:', text);
        Events.emitIframeEvent({ method: iframe.YOUTH_OUTPUT, data: text })
      },
      builtinRead(x) {
        if (Sk.builtinFiles === undefined || Sk.builtinFiles["files"][x] === undefined)
          throw "File not found: '" + x + "'";
        return Sk.builtinFiles["files"][x];
      },
      skulptInput() {
        return new Promise((resolve) => {
          this.inputCallback = resolve;
          // console.log('python need input:')
          Events.emitIframeEvent({ method: iframe.YOUTH_GET_INPUT, data: '' })
        })
      },
      showFrame(boo) {
        console.log('--this.:', this.isSkulptDraw);
        this.isShowFrame = boo;
      },
    }
  }
</script>

<style lang="scss" scoped>

  @import "../../assets/scss/base/config.scss";

  #c-python-runtime {
    display: flex;
    flex-direction: column;
    border-left: 1px solid #b4b4b4;
    position: relative;

    .python-runtime-title-bar {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0 0 0 5px;
      border-bottom: 1px solid #dddddd;
    }

    .python-runtime-title-btn {
      padding: 5px;
      font-size: 14px;
    }

    .mycanvas {
      height: 480px;
      width: 480px;
    }

    .python-over {
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: rgba(255,255,255,0.01);
    }
  }
</style>
